export class Customer {
    public id?: Nullable<number>;
    public name?: Nullable<string>;
    public siret?: Nullable<string>;
    public isActive?: Nullable<boolean>;
}